import { Box } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";

const RecordTooltipContent = ({ record }) => {
  return (
    <Box className="RecordTooltipContent">
      {Object.keys(record)
        .sort((a, b) => {
          if (a === "id") return -1;
          if (b === "id") return 1;
          return a.localeCompare(b);
        })
        .map((field, idx) => (
          <Box key={idx} className="RecordTooltipItem">
            {field}: {JSON.stringify(record[field])}
          </Box>
        ))}
    </Box>
  );
};

export const RecordTooltip = ({ record, children, ...props }) => {
  const content = <RecordTooltipContent record={record} />;

  return (
    <Tooltip title={content} {...props}>
      <Box className="RecordTooltipWrapper">{children}</Box>
    </Tooltip>
  );
};
